import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useDispatch, useSelector } from 'react-redux';
import { USER_ACTIONS } from '../../redux/actions';
import { Paper } from '@material-ui/core';
import useLanguage from '../../hooks/UseLanguage';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.palette.background.default,
    padding: theme.spacing(4)
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function LoginForm() {

  const classes = useStyles();
  const t = useLanguage()

  const dispatch = useDispatch()
  const userLogin = credentials => dispatch(USER_ACTIONS.userLoginAction(credentials))

  const [formData, setformData] = useState({
    user:"wcadmin",
    password:"WcAdmin123!"
  })

  const user = useSelector(state => state.user.user)

  const attemptSubmit = (e) => {
    e.preventDefault()
    userLogin(formData)
  }

  const onChange = (key, e) => {
    setformData({
      ...formData,
      [key]: e.target.value
    })
  }

  return (
    <Container component="main" maxWidth="xs"  >
      <Paper className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {t('login.title')}
        </Typography>
        <form className={classes.form} onSubmit={attemptSubmit} >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="user"
            label={t('login.input.user')}
            name="user"
            autoComplete="user"
            autoFocus
            value={formData.user}
            onChange={e => onChange("user", e)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label={t('login.input.password')}
            type="password"
            id="password"
            value={formData.password}
            onChange={e => onChange("password", e)}
            autoComplete="current-password"
          />
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label={t('login.input.rememberme')}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            {t('actions.login')}
          </Button>
          {/* <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid> */}
        </form>
      </Paper>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}